var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['portal-banner', { 'portal-banner--mobile': _vm.mobile }]},[_c('div',{class:[
      'portal-banner__content',
      { 'portal-banner__content--mobile': _vm.mobile }
    ]},[(!_vm.mobile)?_c('div',{staticClass:"portal-banner__icon",attrs:{"aria-hidden":"true"}},[_c('svg',{staticClass:"portal-banner__icon-svg",attrs:{"viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"26","cy":"26","r":"14","stroke":"currentColor","stroke-width":"6"}}),_c('path',{attrs:{"d":"M36 36L50 50","stroke":"currentColor","stroke-width":"6","stroke-linecap":"round"}})])]):_vm._e(),_c('div',{class:[
        'portal-banner__title',
        { 'portal-banner__title--mobile': _vm.mobile }
      ]},[_c('div',{class:[
          'portal-banner__label',
          { 'portal-banner__label--mobile': _vm.mobile }
        ]},[_vm._v(" PORTAL DE TRÁMITES Y SERVICIOS ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }